<template>
    <div>
        <DialogPrime
            :header="$t('auxiliaryEngine')"
            v-model:visible="displayBasic"
            :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
            :style="{ width: '75vw' }"
        >
            <div class="formgrid grid">
                <div class="field col-12 md:col-6">
                    <label for="name">{{ $t("name") }}</label>
                    <InputTextPrime
                        id="name"
                        v-model="name"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    />
                </div>
                <div class="field col-12 md:col-6">
                    <p>{{ $t("propulsionType") }}</p>
                    <DropdownPrime
                        id="a"
                        v-model="propulsionType"
                        :options="propulsionTypeOptions"
                        v-on:change="onPropulsionTypeChanged"
                        optionLabel="name"
                        placeholder="Propulsion Type"
                        class="field col-12"
                    ></DropdownPrime>
                </div>

                <div class="field col-12 md:col-6">
                    <label>{{ $t("fuelType") }}</label>
                    <DropdownPrime
                        v-model="fuelType"
                        :options="fuelTypeOptions"
                        optionLabel="name"
                        placeholder="Tipo de Combustible"
                        class="field col-12"
                        id="inputField"
                    ></DropdownPrime>
                </div>

                <div v-if="propulsionType && propulsionType.code === 'STM'" class="field col-12 md:col-6">
                    <label for="fuelConsumption">{{ $t("fuelConsumption") }} (g/h)</label>
                    <InputTextPrime
                        id="fuelConsumption"
                        v-model="fuelConsumption"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    />
                </div>

                <div v-else class="field col-12 md:col-6">
                    <label for="sfcae"
                        >{{ $t("certifiedFuelConsumption") }} - <strong>SFC<sub>AE</sub></strong> (g/kWh)</label
                    >
                    <InputTextPrime
                        id="sfcae"
                        v-model="sfcae"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    />
                </div>

                <div class="field col-12 md:col-6">
                    <label>{{ $t("electricalPowerConsumption") }} - HLOAD<sub>max</sub> (kWh)</label>
                    <InputTextPrime
                        v-model="hload"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    />
                </div>

                <div class="field col-12 md:col-6">
                    <label
                        >{{ $t("averageWeight") }} - <strong>&#951;<sub>Gen</sub></strong></label
                    >
                    <InputTextPrime
                        v-model="pigen"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    />
                </div>

                <div class="field col-12 md:col-2">
                    <label for="shaftMotorElement">{{ $t("shaftMotor") }}</label>
                    <SelectButton
                        id="shaftMotorElement"
                        v-model="shaftMotor"
                        :options="shaftMotorOptions"
                        optionLabel="name"
                        :disabled="!(propulsionType && propulsionType.code != dieselElectricCode)"
                    />
                </div>

                <div v-if="shaftMotor && shaftMotor.code === 'YES'" class="field col-12 md:col-4">
                    <label for="psmmax"
                        >{{ $t("ratedPower") }} - <strong>PSM<sub>max</sub></strong> (kW)</label
                    >
                    <InputTextPrime
                        id="psmmax"
                        v-model="psmmax"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    />
                </div>
                <div v-if="shaftMotor && shaftMotor.code === 'YES'" class="field col-12 md:col-4">
                    <label
                        >{{ $t("shaftMotorEfficiency") }} - <strong>n<sub>PTI</sub></strong></label
                    >
                    <InputTextPrime
                        v-model="npti"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    />
                </div>
                <div v-else class="field col-12 md:col-8">
                    <span></span>
                </div>
                <div class="field col-12 md:col-4">
                    <span></span>
                </div>

                <div v-if="shipType === LNGCode" class="field col-12 md:col-4">
                    <label for="reliquefactionElement">{{ $t("reliquefaction") }}</label>
                    <SelectButton
                        id="reliquefactionElement"
                        v-model="reliquefaction"
                        :options="reliquefactionOptions"
                        optionLabel="name"
                    />
                </div>
                <div v-else class="field col-12 md:col-4">
                    <span></span>
                </div>

                <div v-if="reliquefaction && reliquefaction.code === 'YES'" class="field col-12 md:col-4">
                    <label for="cargoTankCapacityElement"
                        >{{ $t("cargoTank") }} -
                        <strong>{{ $t("cargoTankCapacity") }}<sub>LNG</sub></strong> (m&sup3;)</label
                    >
                    <InputTextPrime
                        id="cargoTankCapacityElement"
                        v-model="cargoTankCapacity"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    />
                </div>
                <div v-else class="field col-12 md:col-4">
                    <span></span>
                </div>

                <div v-if="reliquefaction && reliquefaction.code === 'YES'" class="field col-12 md:col-4">
                    <label for="borElement">Rate of boil-off gas per day - <strong>BOR</strong> (%)</label>
                    <InputTextPrime
                        id="borElement"
                        v-model="bor"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    />
                </div>
                <div v-else class="field col-12 md:col-4">
                    <span></span>
                </div>

                <div class="field col-12 md:col-4">
                    <span></span>
                </div>

                <div v-if="reliquefaction && reliquefaction.code === 'YES'" class="field col-12 md:col-4">
                    <label for="bogReliquefyElement"
                        >Boil-off gas to be re-liquefied - <strong>BOG<sub>reliquefy</sub></strong> (m&sup3;)</label
                    >
                    <InputTextPrime
                        id="bogReliquefyElement"
                        v-model="bogReliquefy"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    />
                </div>
                <div v-else class="field col-12 md:col-4">
                    <span></span>
                </div>

                <div v-if="reliquefaction && reliquefaction.code === 'YES'" class="field col-12 md:col-4">
                    <label for="bogTotalElement"
                        >Entire boil-off gas - <strong>BOG<sub>total</sub></strong> (m&sup3;)</label
                    >
                    <InputTextPrime
                        id="bogTotalElement"
                        v-model="bogTotal"
                        class="text-base text-color surface-overlay p-3 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    />
                </div>
                <div v-else class="field col-12 md:col-4">
                    <span></span>
                </div>

                <div v-if="shipType === LNGCode" class="field col-12 md:col-4">
                    <label for="highPressureGasCompressorElement">{{ $t("highPressureGasCompressor") }}</label>
                    <SelectButton
                        id="highPressureGasCompressorElement"
                        v-model="highPressureGasCompressor"
                        :options="highPressureGasCompressorOptions"
                        optionLabel="name"
                    />
                </div>
                <div v-else class="field col-12 md:col-4">
                    <span></span>
                </div>

                <div v-if="shipType === LNGCode" class="field col-12 md:col-4">
                    <label for="lowPressureGasCompressorElement">{{ $t("lowPressureGasCompressor") }}</label>
                    <SelectButton
                        id="lowPressureGasCompressorElement"
                        v-model="lowPressureGasCompressor"
                        :options="lowPressureGasCompressorOptions"
                        optionLabel="name"
                    />
                </div>
                <div v-else class="field col-12 md:col-4">
                    <span></span>
                </div>

                <div class="field col-12 md:col-6" v-if="isDual()">
                    <label for="vliquidElement"
                        >{{ $t("vliquid") }} -
                        <strong
                            >V<sub>{{ $t("liquid") }}</sub></strong
                        >
                        (m&#179;)</label
                    >
                    <InputTextPrime type="number" id="inputField" v-model="vliquid" :style="{ width: '35vw' }" />
                </div>
                <div class="field col-12 md:col-6" v-if="isDual()">
                    <label for="vgasElement"
                        >{{ $t("vgas") }} - <strong>V<sub>gas</sub></strong> (m&#179;)</label
                    >
                    <InputTextPrime type="number" id="inputField" v-model="vgas" :style="{ width: '35vw' }" />
                </div>
                <div class="field col-12 md:col-6" v-if="isDual()">
                    <label for="kliquidElement"
                        >{{ $t("kliquid") }} -
                        <strong
                            >K<sub>{{ $t("liquid") }}</sub></strong
                        >
                        (m&#179;/h)</label
                    >
                    <InputTextPrime type="number" id="inputField" v-model="kliquid" :style="{ width: '35vw' }" />
                </div>
                <div class="field col-12 md:col-6" v-if="isDual()">
                    <label for="kgasElement"
                        >{{ $t("kgas") }} - <strong>K<sub>gas</sub></strong> (m&#179;/h)</label
                    >
                    <InputTextPrime type="number" id="inputField" v-model="kgas" :style="{ width: '35vw' }" />
                </div>
                <div class="field col-12 md:col-6" v-if="isDual()">
                    <label for="sfcliquidElement"
                        >{{ $t("sfcLiquid") }} –
                        <strong
                            >SFC<sub>{{ $t("liquid") }}</sub></strong
                        >
                        (g/kWh)</label
                    >
                    <InputTextPrime type="number" id="inputField" v-model="sfcliquid" :style="{ width: '35vw' }" />
                </div>
                <div class="field col-12 md:col-6" v-if="isDual()">
                    <label for="sfcgasElement"
                        >{{ $t("sfcGas") }} - <strong>SFC<sub>gas</sub></strong> (g/kWh)</label
                    >
                    <InputTextPrime type="number" id="inputField" v-model="sfcgas" :style="{ width: '35vw' }" />
                </div>
                <div class="field col-12 md:col-6" v-if="isDual()">
                    <label for="sfcmepilotElement"
                        >{{ $t("sfcmePilot") }} – <strong>SFC<sub>MEpilot</sub></strong> (g/kWh)</label
                    >
                    <InputTextPrime type="number" id="inputField" v-model="sfcmepilot" :style="{ width: '35vw' }" />
                </div>
                <div class="field col-12 md:col-6" v-if="isDual()">
                    <p>{{ $t("secondFuel") }}</p>
                    <DropdownPrime
                        v-model="secondFuelType"
                        :options="fuelTypeOptions"
                        optionLabel="name"
                        placeholder="Select second fuel type"
                        id="secondFuelTypeElement"
                        class="field col-12"
                    ></DropdownPrime>
                </div>
            </div>
            <template #footer>
                <ButtonPrime :label="$t('cancel')" icon="pi pi-times" @click="closeBasic" class="p-button-text" />
                <ButtonPrime :label="$t('confirm')" icon="pi pi-check" @click="saveAndClose" autofocus />
            </template>
        </DialogPrime>
    </div>
</template>

<script>
import store from "@/store/index"
import { propulsionTypeCodes, shipTypeCodes } from "../utils/constants"
import ShipPartService from "@/services/ShipPartService"
import ParametricTableService from "@/services/ParametricTableService"
import { config } from "@/utils/configuration/config"

export default {
    name: "AddAuxEngineEmissionsComponent",
    data: () => {
        return {
            name: "",
            id: "",
            displayBasic: false,
            propulsionType: null,
            propulsionTypeOptions: [],
            powerLimit: null,
            powerLimitOptions: [],
            powerLimitValue: 0,
            fuelType: null,
            fuelTypeOptions: [],
            secondFuelType: null,
            sfcae: 215,
            fuelConsumption: 0,
            shaftMotor: null,
            shaftMotorOptions: [],
            nominalElectricPower: 0,
            vgas: 0,
            kgas: 0,
            sfcgas: 0,
            vliquid: 0,
            kliquid: 0,
            sfcliquid: 0,
            sfcaepilot: 0,
            mcrpto: 0,
            psmmax: 0,
            npti: 1,
            pigen: 0,
            cargoTankCapacity: 0,
            bor: 0,
            reliquefaction: false,
            bogReliquefy: 0,
            bogTotal: 0,
            pae: 1,
            cfae: 0,
            ppti: 0,
            hload: 0,
            mcrme: 0,
            lowPressureGasCompressor: false,
            highPressureGasCompressor: false,
            steamTurbineCode: propulsionTypeCodes.SteamTurbine,
            dieselElectricCode: propulsionTypeCodes.DieselElectric,
            dualCode: propulsionTypeCodes.Dual,
            dieselElectricDualCode: propulsionTypeCodes.DieselElectricDual,
            ROPAXCode: shipTypeCodes.ROPAX,
            LNGCode: shipTypeCodes.LNG,
            PassengersCode: shipTypeCodes.Passengers,
            shipType: "",
            shipGt: 0
        }
    },
    props: {
        editElementId: Object
    },

    watch: {
        editElementId: function (newVal, oldVal) {
            // watch it
            console.log("Prop changed: ", newVal ? newVal.name : "", " | was: ", oldVal ? oldVal.name : "")
            this.id = newVal.id
            this.name = newVal.name

            this.propulsionType = this.findElementInOptions(newVal.propulsionType, this.propulsionTypeOptions)
            this.fuelType = this.findElementInOptions(newVal.fuelType, this.fuelTypeOptions)
            this.shaftMotor = this.findElementInOptions(newVal.shaftMotor ? "YES" : "NO", this.shaftMotorOptions)
            this.powerLimit = this.findElementInOptions(newVal.powerLimit ? "YES" : "NO", this.powerLimitOptions)

            this.powerLimitValue = newVal.powerLimitValue
            this.secondFuelType = newVal.secondFuelType
            this.fuelConsumption = newVal.fuelConsumption
            this.nominalElectricPower = newVal.nominalElectricPower

            newVal.vgas != undefined ? (this.vgas = newVal.vgas) : (this.vgas = 0)
            newVal.kgas != undefined ? (this.kgas = newVal.kgas) : (this.kgas = 0)
            newVal.sfcgas != undefined ? (this.sfcgas = newVal.sfcgas) : (this.sfcgas = 0)
            newVal.vliquid != undefined ? (this.vliquid = newVal.vliquid) : (this.vliquid = 0)
            newVal.kliquid != undefined ? (this.kliquid = newVal.kliquid) : (this.kliquid = 0)
            newVal.sfcliquid != undefined ? (this.sfcliquid = newVal.sfcliquid) : (this.sfcliquid = 0)
            newVal.sfcmepilot != undefined ? (this.sfcmepilot = newVal.sfcmepilot) : (this.sfcmepilot = 0)
            newVal.cfae != undefined ? (this.cfae = newVal.cfae) : (this.cfae = 215)

            this.mcrpto = newVal.mcrpto
            this.psmmax = newVal.psmmax
            this.npti = newVal.npti ? newVal.npti : 1
            this.pigen = newVal.pigen
            this.cargoTankCapacity = newVal.cargoTankCapacity
            this.bor = newVal.bor
            this.reliquefaction = newVal.reliquefaction
            this.bogReliquefy = newVal.bogReliquefy
            this.bogTotal = newVal.bogTotal
            this.lowPressureGasCompressor = newVal.lowPressureGasCompressor
            this.highPressureGasCompressor = newVal.highPressureGasCompressor
            this.pae = newVal.pae
            this.ppti = newVal.ppti
            this.hload = newVal.hload
            this.mcrme = newVal.mcrme

            this.displayBasic = true
        }
    },

    created() {
        ParametricTableService.getInstance().getParametricTable(config.firebaseConfig.parametricVersion)
    },
    mounted() {
        console.log("Propulsion Type antes", this.propulsionTypeOptions)
        const parametricTables = ParametricTableService.getInstance().getParametricTable(
            config.firebaseConfig.parametricVersion
        )
        console.log("parametricTables", parametricTables)
        this.propulsionTypeOptions = parametricTables.propulsionType
        this.fuelTypeOptions = parametricTables.fuelType
        this.powerLimitOptions = parametricTables.yesNoType
        this.shaftMotorOptions = parametricTables.yesNoType
        this.reliquefactionOptions = parametricTables.yesNoType
        this.highPressureGasCompressorOptions = parametricTables.yesNoType
        this.lowPressureGasCompressorOptions = parametricTables.yesNoType
        console.log("Propulsion Type después", this.propulsionTypeOptions)
        console.log("shipType", this.shipType)

        this.shipType = store.getters.currentShip.shipType
        this.shipGt = store.getters.currentShip.gt
    },
    methods: {
        closeBasic() {
            this.displayBasic = false
        },
        isDual() {
            return (
                this.propulsionType &&
                (this.propulsionType.code === this.dualCode || this.propulsionType.code === this.dieselElectricDualCode)
            )
        },
        onPropulsionTypeChanged(event) {
            const parametricTables = ParametricTableService.getInstance().getParametricTable(
                config.firebaseConfig.parametricVersion
            )

            this.fuelTypeOptions = []
            parametricTables.fuelType.forEach((fuelType) => {
                if (event.value.fuelTypesValid.includes(fuelType.code)) {
                    this.fuelTypeOptions.push(fuelType)
                }
            })
        },
        saveAndClose() {
            console.log("AddShipPartComponent-saveAndClose", this.name)
            const newPart = {
                id: this.id,
                name: this.name,
                propulsionType: this.propulsionType ? this.propulsionType.code : null,
                fuelType: this.fuelType && this.fuelType.code ? this.fuelType.code : null,
                secondFuelType: this.secondFuelType && this.secondFuelType.code ? this.secondFuelType.code : null,
                powerLimit: this.powerLimit ? this.powerLimit.code === "YES" : false,
                powerLimitValue: this.powerLimitValue ? this.powerLimitValue : 0,
                fuelConsumption: this.fuelConsumption ? this.fuelConsumption : 0,
                shaftMotor: this.shaftMotor ? this.shaftMotor.code === "YES" : false,
                nominalElectricPower: this.nominalElectricPower ? this.nominalElectricPower : 0,
                mcrpto: this.mcrpto ? this.mcrpto : 0,
                vgas: this.vgas ? this.vgas : 0,
                kgas: this.kgas ? this.kgas : 0,
                sfcgas: this.sfcgas ? this.sfcgas : 0,
                vliquid: this.vliquid ? this.vliquid : 0,
                kliquid: this.kliquid ? this.kliquid : 0,
                sfcliquid: this.sfcliquid ? this.sfcliquid : 0,
                sfcaepilot: this.sfcaepilot ? this.sfcaepilot : 0,
                sfcae: this.sfcae ? this.sfcae : 0,
                psmmax: this.psmmax ? this.psmmax : 0,
                npti: this.npti ? this.npti : 1,
                pigen: this.pigen ? this.pigen : 0,
                mcrme: this.mcrme ? this.mcrme : 0,
                pae: this.pae ? this.pae : 0,
                cfae: this.cfae ? this.cfae : 0,
                ppti: this.ppti ? this.ppti : 0,
                hload: this.hload ? this.hload : 0,
                cargoTankCapacity: this.cargoTankCapacity ? this.cargoTankCapacity : 0,
                bor: this.bor ? this.bor : 0,
                bogReliquefy: this.bogReliquefy ? this.bogReliquefy : 0,
                bogTotal: this.bogTotal ? this.bogTotal : 0,
                reliquefaction: this.reliquefaction ? this.reliquefaction.code === "YES" : false,
                lowPressureGasCompressor: this.lowPressureGasCompressor
                    ? this.lowPressureGasCompressor.code === "YES"
                    : false,
                highPressureGasCompressor: this.highPressureGasCompressor
                    ? this.highPressureGasCompressor.code === "YES"
                    : false
            }

            const parametricTables = ParametricTableService.getInstance().getParametricTable(
                config.firebaseConfig.parametricVersion
            )
            var parametricTablesObj = {
                fuelType: parametricTables.fuelType
            }

            const errors = ShipPartService.getInstance().saveAuxEnginePart(
                store.getters.currentShip.id,
                store.getters.currentConfiguration.id,
                newPart,
                parametricTablesObj,
                this.shipType,
                this.shipGt,
                store.getters.currentConfiguration
            )

            if (errors === "") {
                this.displayBasic = false
                this.$emit("savedElement", "Auxiliary engine", !this.id || this.id === "")
            } else {
                this.$emit("errorSavingElement", "Auxiliary engine", errors)
            }
        },
        editConfig() {
            console.log("editConfig")
            this.displayBasic = true
        },
        findElementInOptions(code, options) {
            var result = {}
            options.forEach((option) => {
                if (option.code === code) {
                    result = option
                }
            })
            return result
        }
    }
}
</script>

<style scoped>
.p-button {
    margin: 10px !important;
}
.field {
    margin-bottom: 15px !important;
}
</style>
